var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOzon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 11.251c2.3 0 4.12.747 5.46 2.241 1.348 1.495 2.022 3.52 2.022 6.076 0 2.556-.67 4.585-2.01 6.086-1.341 1.494-3.165 2.241-5.472 2.241-2.322 0-4.156-.747-5.504-2.24-1.34-1.495-2.01-3.524-2.01-6.087 0-2.556.673-4.581 2.02-6.076 1.356-1.494 3.187-2.24 5.494-2.24zm0 2.516c-1.413 0-2.538.524-3.373 1.571-.827 1.048-1.241 2.457-1.241 4.23 0 1.78.41 3.193 1.23 4.24.828 1.048 1.956 1.572 3.384 1.572 1.406 0 2.52-.524 3.34-1.571.828-1.055 1.241-2.469 1.241-4.241 0-1.773-.413-3.183-1.241-4.23-.82-1.047-1.934-1.57-3.34-1.57z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0259FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzon);
export default __webpack_public_path__ + "static/media/ozon.bf14d83957a747e7af34a953ffbd0dcc.svg";
export { ForwardRef as ReactComponent };